export default __webpack_public_path__ + "static/pay_compare_comp2_active-62a7a28c9a0b7c99940754812726af9c.png";